<template>
  <div class="areaPolicyPage">
    <div class="pageMain">
      <div class="count" v-if="!showNonePage">
        <div v-html="documentMain" class="countHtml"></div>
        <p class="fgx" v-if="baseFiles[0]"></p>
        <div class="download main" v-if="baseFiles[0]">
          <h4 class="ggTit">附件</h4>
          <div class="detailMian">
            <ul>
              <li
                class="clearfix downloadItem"
                v-for="item in baseFiles"
                :key="item.id"
              >
                <dl class="fl" @click="preview(item)">
                  <dt>
                    <img
                      :src="
                        getFormat(item.fileName) == 'jpg' ||
                        getFormat(item.fileName) == 'png' ||
                        getFormat(item.fileName) == 'jpeg'
                          ? item.url
                          : getFormat(item.fileName) == 'pdf'
                          ? '' + baseUrl + 'searchImg/pdf.png'
                          : getFormat(item.fileName) == 'xlsx' ||
                            getFormat(item.fileName) == 'xls'
                          ? '' + baseUrl + 'searchImg/excel.png'
                          : '' + baseUrl + 'searchImg/word.png'
                      "
                      alt
                    />
                  </dt>
                  <dd class="dtName">
                    <span>{{ item.fileName }}</span>
                    <span>{{ getMb(item.fileSize) }}</span>
                  </dd>
                  <!-- <dd class="Mb">
                    <span>{{ getMb(item.fileSize) }}</span>
                  </dd> -->
                </dl>
                <a
                  href="javascript:void(0);"
                  class="downloadBtn fr"
                  @click="downLoad(item)"
                  >下载</a
                >
              </li>
            </ul>
          </div>
        </div>
        <!-- 视频 -->
        <p class="fgx" v-if="baseVideoFiles[0]"></p>
        <div class="videoBox" v-if="baseVideoFiles[0]">
          <h4 class="ggTit">视频</h4>
          <div class="detailMian">
            <ul>
              <li
                class="clearfix"
                v-for="item in baseVideoFiles"
                :key="item.id"
              >
                <dl @click="onRead(item)">
                  <dt>
                    <img
                      :src="
                        item.coverUrl
                          ? item.coverUrl
                          : baseUrl + 'searchImg/videoPlay.png'
                      "
                      alt
                    />
                  </dt>
                  <dd class="dtName">{{ item.fileName }}</dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="nonePage" v-if="showNonePage">
      <img :src="nonePng" alt />
      <p>暂无数据</p>
    </div>
    <!-- 弹出框 -->
    <van-popup
      v-model="videoShow"
      closeable
      :style="{ width: '100%', height: '300px' }"
      @close="closeVideo"
      class="videoActive"
      ><vedio-player v-if="videoShow" :play="modalVideo"></vedio-player
    ></van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
// import { getToken } from "@/utils/common";
import vedioPlayer from "@/components/vedio-play/vedio-play";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "areaPolicy",
  components: { vedioPlayer },
  data() {
    return {
      userId: "",
      baseUrl: process.env.BASE_URL,
      nonePng: nonePng, //默认图片
      showNonePage: false,
      documentMain: "",
      baseFiles: [],
      baseVideoFiles: [], //视频来源
      modalVideo: {}, //播放源
      videoShow: false,
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    if (this.dataInfo.id) {
      this.documentMain = this.dataInfo.document;
      if (this.dataInfo.baseFiles.length < 0) {
        this.baseFiles = [];
      } else {
        this.baseFiles = this.dataInfo.baseFiles;
      }
      if (this.dataInfo.baseVideoFiles.length < 0) {
        this.baseVideoFiles = [];
      } else {
        let videoDataList = this.dataInfo.baseVideoFiles,
          newArr = [];
        videoDataList.forEach((item, index) => {
          this.$api.universal.dutyArea.getPlayauth(item.url).then((res) => {
            if (res.code == "1") {
              item.coverUrl = res.data.coverURL;
              newArr.push(item);
            } else {
              this.$toast(res.msg);
            }
          });
        });
        console.log(newArr);
        this.$nextTick(() => {
          this.baseVideoFiles = newArr;
        });
      }
    }
  },
  methods: {
    downLoad(data) {
      console.log(data);
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(115,data.url);
      } else {
        let dataArguments = {
          url: data.url,
          fileName: data.fileName,
          twoArguments: "",
        };
        if (
          this.getFormat(data.fileName) == "jpg" ||
          this.getFormat(data.fileName) == "png" ||
          this.getFormat(data.fileName) == "jpeg"
        ) {
          dataArguments.twoArguments = "picture";
        }
        window.webkit.messageHandlers.downLoad.postMessage(
          JSON.stringify(dataArguments)
        );
      }
    },
    preview(data) {
      //原生交互预览
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(115, JSON.stringify(data.url));
      } else {
        window.webkit.messageHandlers.preview.postMessage(JSON.stringify(data));
      }
    },
    onRead(data) {
      let _this = this;
      console.log(data);
      _this.$api.universal.dutyArea.getPlayauth(data.url).then((res) => {
        if (res.code == "1") {
          _this.modalVideo = res.data;
          _this.videoShow = true;
        } else {
          _this.$toast(res.msg);
        }
      });
    },
    closeVideo() {
      this.videoShow = false;
      this.modalVideo = {};
    },
    getMb(Kb) {
      let size = "";
      size = (Kb / 1024 / 1024).toFixed(4) + "MB";
      return size;
    },
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;
        if (_this.dataInfo.id) {
          _this.documentMain = this.dataInfo.document;
          if (this.dataInfo.baseFiles.length < 1) {
            _this.baseFiles = [];
          } else {
            _this.baseFiles = _this.dataInfo.baseFiles;
          }
          if (this.dataInfo.baseVideoFiles.length < 0) {
            this.baseVideoFiles = [];
          } else {
            let videoDataList = this.dataInfo.baseVideoFiles,
              newArr = [];
            videoDataList.forEach((item) => {
              this.$api.universal.dutyArea.getPlayauth(item.url).then((res) => {
                if (res.code == "1" && res.data != null) {
                  this.$set(item, "coverUrl", res.data.coverURL);
                  newArr.push(item);
                } else {
                  this.$toast(res.msg);
                }
              });
            });
            this.baseVideoFiles = newArr;
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.areaPolicyPage {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #f6f6f6;

  p.fgx {
    width: 100%;
    height: 8px;
    background-color: #f6f6f6;
  }
  h4.ggTit {
    position: relative;
    border-bottom: 1px solid #f6f6f6;
    line-height: 45px;
    padding: 0 20px;
    font-weight: 700;
    color: #35c476;
    font-size: 14px;
    z-index: 10;
    background-color: #fff;
  }
  .pageMain {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding-bottom: 30px;
    overflow-y: scroll;
    .count {
      width: 100%;

      padding-bottom: 20px;
      .countHtml {
        margin-top: 6px;
        padding: 0 16px 8px;

        img {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          display: block;
        }

        p {
          font-size: 14px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: #333;
          line-height: 20px;

          padding-bottom: 60px;
        }
      }
      .download {
        width: 100%;
        // padding: 0 16px;
        .detailMian {
          width: 100%;
          margin-top: 10px;
          padding: 0 16px;
          li {
            width: 100%;
            height: 50px;
            margin: 8px 0;
            padding-bottom: 10px;
            border-bottom: 1px solid #f6f6f6;
            dl {
              width: 85%;
              position: relative;

              dt {
                display: block;
                width: 40px;
                height: 40px;

                position: absolute;
                img {
                  max-width: 100%;
                  max-height: 100%;
                }
              }

              dd {
                display: block;
                font-size: 10px;
                color: #999;
              }

              dd.dtName {
                font-size: 12px;
                color: #666;
              
                margin-left: 50px;
                 > span {
                  display: block;
                }
              }
              
            }
          }
          li:last-child {
            border: 0 none;
          }

          a {
            margin-top: 5px;
            display: block;
            font-size: 12px;
            color: #35c476;
            width: 30px;
            height: 30px;
            line-height: 30px;
          }
        }
      }
      .videoBox {
        width: 100%;

        .detailMian {
          width: 100%;
          height: 100%;
          margin-top: 10px;
          padding: 0 16px;
          ul {
            max-height: 350px;
            overflow-y: scroll;
            margin-bottom: 20px;
            li {
              border-bottom: 1px solid #f6f6f6;
              dl {
                width: 100%;
                margin: 8px 0;
                dt {
                  width: 100%;
                  display: block;
                  margin-bottom: 5px;
                  img {
                    display: block;
                    margin: 0 auto;
                    max-height: 100px;
                    max-width: 100%;
                  }
                }
                dd {
                  display: inline-block;
                  width: 100%;
                  text-align: center;
                  font-size: 12px;
                  color: #333;
                }
              }
            }
            li:first-child {
              margin-top: 0;
            }
            li:last-child {
              border: 0 none;
            }
          }
        }
      }
    }
  }
  .nonePage {
    width: 120px;
    height: 150px;
    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
}
</style>